const CollapsiblePanelComponent = function () {
    const self = this;

    const classMap = {
        toggle: ".js-collapsible-panel__toggle",
        content: ".js-collapsible-panel__content"
    };

    let $currentContext = $();
    let $toggle, $content;

    function scrollToAnchoredElement(elementId) {
        const elementSelector = `#${ elementId }`;
        const $element = $(elementSelector, $currentContext);

        if ($element.length) {
            const isFirstElement = $content.children().first()[0] === $element.parent()[0] /*tiny mce creates an anchor inside selected tag ( h5 > h5 a)*/;
            const scrollTarget = isFirstElement ? $toggle : $element;
            const topOffset = scrollTarget.offset().top;
            $("html").scrollTop(topOffset);
        }
    }

    this.expand = function () {
        $content.collapse("show");
    };

    this.collapse = function () {
        $content.collapse("hide");
    };

    this.hasAnchoredElement = function (elementId) {
        if (!$.isValidElementId(elementId)) {
            return;
        }

        const elementSelector = `#${ elementId }`;
        return !!$content.find(elementSelector).length;
    };

    this.showAnchoredElement = function (elementId) {
        if (!$.isValidElementId(elementId)) {
            return;
        }

        self.expand();
        scrollToAnchoredElement(elementId);
    };

    function parseContext() {
        $toggle = $(classMap.toggle, $currentContext);
        $content = $(classMap.content, $currentContext);
    }

    this.init = function (context) {
        $currentContext = context || $currentContext;
        parseContext();
    };
};

Object.defineProperty(CollapsiblePanelComponent, "SELECTOR", {
    enumerable: false,
    configurable: false,
    writable: false,
    value: ".js-collapsible-panel"
});

module.exports = CollapsiblePanelComponent;
